import { BaseIconProps } from './types';

export function Cart({
  width = 24,
  height = 24,
  className,
}: BaseIconProps & { className?: string }) {
  return (
    <svg
      width={className ? undefined : width}
      height={className ? undefined : height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.792 2H1V4H4.218L6.988 16.678H7V17H20V16.752L22.193 7.091L22.531 6H6.655L6.085 3.389L5.792 2ZM19.987 8H7.092L8.621 15H18.398L19.987 8Z"
        fill="#111111"
      />
      <path
        d="M10 22C10.5304 22 11.0391 21.7893 11.4142 21.4142C11.7893 21.0391 12 20.5304 12 20C12 19.4696 11.7893 18.9609 11.4142 18.5858C11.0391 18.2107 10.5304 18 10 18C9.46957 18 8.96086 18.2107 8.58579 18.5858C8.21071 18.9609 8 19.4696 8 20C8 20.5304 8.21071 21.0391 8.58579 21.4142C8.96086 21.7893 9.46957 22 10 22ZM19 20C19 20.5304 18.7893 21.0391 18.4142 21.4142C18.0391 21.7893 17.5304 22 17 22C16.4696 22 15.9609 21.7893 15.5858 21.4142C15.2107 21.0391 15 20.5304 15 20C15 19.4696 15.2107 18.9609 15.5858 18.5858C15.9609 18.2107 16.4696 18 17 18C17.5304 18 18.0391 18.2107 18.4142 18.5858C18.7893 18.9609 19 19.4696 19 20Z"
        fill="#111111"
      />
    </svg>
  );
}
